import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'option-filter',
  styleUrls: ['./option-filter.component.scss'],
  templateUrl: './option-filter.component.html',
})
export class OptionFilterComponent {
  @Input() filter: string = '';

  @Input() autoFocus: boolean;
  @Input() placeholder: string = 'Search...';
  @Input() disabled: boolean;
  @Input() filterEmpty: boolean;
  @Input() hideOptions: boolean = false;
  @HostBinding('class.input-position-bottom')
  @Input()
  inputPositionBottom: boolean;
  @Input()
  queryParamName: string;

  @Output() filterChange = new EventEmitter<string>();
  @Output() focus = new EventEmitter();
  @Output() blur = new EventEmitter();
  @Input()
  type: 'text' | 'email' | 'number' | 'password' | 'search' | 'tel' | 'url' =
    'text';

  filterChanged(value: string) {
    this.filterChange.emit(value);
  }

  filterKeydown(evt: KeyboardEvent) {
    switch (evt.key) {
      case 'Esc':
      case 'Escape':
        if (this.filter && this.filter.length) {
          evt.stopPropagation();
          this.filterChanged('');
        }
        break;
    }
  }
}
